import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ErrorPayload } from "../../../../interfaces/auth/IErrorPayload";
import { UserPassPayload } from "../../../../interfaces/auth/IUser";
import { useLoginMutation } from "../../../../store/auth/authApi";
import Input from "../../../../shared/input";
import Loading from "../../../../shared/Loading";


const LoginForm = () => {
    const { register, handleSubmit, formState: { errors } } = useForm<UserPassPayload>();
    const [loginMutation, { isLoading, error }] = useLoginMutation();
    const navigate = useNavigate();
    let errorMsg: any

    const onSubmit = async (payload: UserPassPayload) => {
        try {
            const { data } = await loginMutation(payload).unwrap();
            const roles = data.servicePayload.accessToken.payload["cognito:groups"];
            localStorage.setItem('accessToken', data.token);
            localStorage.setItem('refreshToken', data.refreshToken);
            localStorage.setItem('roles', roles?.[0] || "");
            navigate(roles?.[0] === 'admins' ? "/users" : roles?.[0] === 'suppliers' ? '/invoices' : "/calls");
        } catch (err: any) {
            errorMsg = err?.data?.message
        }
    }

    const err = { ...error as ErrorPayload };
    errorMsg = err.status === 401 ? "Username or password are incorrect" : "Something went wrong";
    return (
        <>
            <form className="mt-8 mb-5" onSubmit={handleSubmit(onSubmit)}>
                {!!err.data && <div className="p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-200 dark:text-red-800" role="alert">
                    <span className="font-medium"> {err.data.message || errorMsg} </span>
                </div>}
                <Input
                    placeholder="Enter username or email address"
                    register={register('username', {
                        required: {
                            message: 'Username is required',
                            value: true,
                        },
                        validate: (value: string) => !!value.trim() || 'Username is required'
                    })}
                    error={errors.username?.message}
                />
                <Input
                    placeholder="Password"
                    type="password"
                    register={register('password', {
                        required: {
                            message: 'Password is required',
                            value: true,
                        },
                    })}
                    error={errors.password?.message}
                />
                <button className=" mt-1 w-full justify-center flex bg-authPrimary py-2 px-5 text-white rounded" type="submit">
                    {isLoading && <Loading />}
                    Login
                </button>
            </form>
        </>
    )
}

export default LoginForm;